import { selectCurrentBuilder } from "@app/features/builder/builderSlice";
import { useAppSelector } from "@app/hooks";
import { motion } from "framer-motion";
import { soilData } from "./guidanceUtils";
import TranslatableText from "@components/translations/TranslatableText";
import { useLocation } from "react-router-dom";
import { getModuleFromUrl } from "@utils/moduleList";
import { useMemo } from "react";

const GuidanceAction = () => {
  const { tabsOpen } = useAppSelector(selectCurrentBuilder);
  const location = useLocation();
  const areWeInBuilder = location.pathname?.includes("builder");

  return (
    <motion.section
      className="bg-gray w-100 h-100 d-flex f-column p-2"
      initial={{ width: 0 }}
      animate={{ width: tabsOpen ? "inherit" : 0 }}
      exit={{ width: 0 }}
    >
      <div className="pos-relative mb-2">
        <h2 className="fs-14 ff-medium-ext module-header w-fit">
          <TranslatableText translationKey={areWeInBuilder ? "main.video_guide" : "main.soil_classification"} />
        </h2>
      </div>

      {areWeInBuilder ? <VideoGuide /> : <SoilClassificationTable />}
    </motion.section>
  );
}

const VideoGuide = () => {
  const location = useLocation();
  const FEModule = useMemo(() => getModuleFromUrl(location.pathname), [location.pathname]);
  const videoId: string | undefined = useMemo(() => FEModule?.youtubeId, [FEModule]);

  return (
    <div className="d-flex f-column align-items-center w-100">
      {videoId ? (
        <div className="w-100" style={{ aspectRatio: '16/9', position: 'relative' }}>
          <iframe
            style={{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0 }}
            src={`https://www.youtube.com/embed/${videoId}`}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen />
        </div>
      ) : (
        <div className="text-center p-4">
          <TranslatableText translationKey="main.no_video_available" />
        </div>
      )}
    </div>
  )
}

const SoilClassificationTable = () => {
  return (
    <div className="soil-classification-table">
      <div className="soil-classification-table__container">
        <table className="soil-classification-table__table">
          <thead className="soil-classification-table__thead">
            <tr>
              <th className="soil-classification-table__th fs-12 ff-medium-ext">HWSD v1.2</th>
              <th className="soil-classification-table__th fs-12 ff-medium-ext">IPCC</th>
            </tr>
          </thead>
          <tbody>
            {soilData.map((soil, index) => (
              <tr key={index} className="soil-classification-table__tr">
                <td className="soil-classification-table__td">{soil.hwsd}</td>
                <td className="soil-classification-table__td">{soil.ipcc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default GuidanceAction;